// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React from 'react';
import { Icon } from '@fluentui/react';
import { isMessageTooLong } from './SendBoxUtils';
/**
 * @private
 */
export const onRenderCancelIcon = (className: string): JSX.Element => {
  return <Icon iconName={'EditBoxCancel'} className={className} />;
};

/**
 * @private
 */
export const onRenderSubmitIcon = (className: string): JSX.Element => {
  return <Icon iconName={'EditBoxSubmit'} className={className} />;
};
type MessageState = 'OK' | 'too short' | 'too long';
function isMessageEmpty(messageText: string): boolean {
  return messageText.trim().length === 0;
}

/**
 * @private
 */
export function getMessageState(messageText: string): MessageState {
  return isMessageEmpty(messageText) ? 'too short' : isMessageTooLong(messageText.length) ? 'too long' : 'OK';
}